// Los pasos que el vendedor ejecuta EN EL TELÉFONO para el candado (paso 09, crédito), por proveedor
// y, en Trustonic, por método de alta del equipo.

export interface DeviceEnrollmentStep {
    /** La acción, en imperativo — es lo que el vendedor busca con la vista. */
    action: string;
    /** El cómo, cuando la acción sola no alcanza para ejecutarla sin dudar. */
    detail?: string;
}

/**
 * El paso 1 no es un paso más: el aprovisionamiento de los pasos 6-8 no funciona si el equipo ya
 * tiene una cuenta configurada. Por eso además se anuncia arriba, antes de teclear el IMEI.
 */
export const DEVICE_ENROLLMENT_STEPS: readonly DeviceEnrollmentStep[] = [
    {
        action: 'Termina la configuración inicial del equipo en modo offline',
        detail: 'Sin conectarlo a una red y sin agregar ninguna cuenta de Google.',
    },
    {
        action: 'Abre Chrome y escanea el código QR',
        detail: 'En la pantalla de inicio: Chrome → «Usar sin cuenta» → escanea el código. Empieza a descargarse la app.',
    },
    {
        action: 'Toca «Descargar» y permite la instalación',
        detail: 'Cuando salga el aviso, entra a Ajustes y permite instalar aplicaciones desde Chrome. Al terminar, toca «Abrir».',
    },
    {
        action: 'Permite las notificaciones y toca «Get started»',
        detail: 'Sigue las instrucciones que muestre la app.',
    },
    {
        action: 'Cambia el tiempo de apagado de pantalla a 30 minutos',
    },
    {
        action: 'Toca «Enable» y activa las opciones de desarrollador',
        detail: 'Toca 7 veces el número de versión, hasta que el equipo diga que ya eres desarrollador.',
    },
    {
        action: 'Vuelve a la app y activa la depuración inalámbrica',
        detail: '«Next» → «Enable» → activa la depuración inalámbrica → «Next».',
    },
    {
        action: 'Vincula el dispositivo con el código de emparejamiento',
        detail: 'Teclea el código que aparece en la notificación y envíalo. Espera hasta ver «depuración inalámbrica conectada».',
    },
    {
        action: 'En la pantalla de datos toca «Skip» y acepta el contrato',
    },
    {
        action: 'Vuelve al inicio: el equipo ya aparece registrado',
    },
];

const FACTORY_FRESH_STEP: DeviceEnrollmentStep = {
    action: 'Usa el equipo nuevo o restablecido de fábrica',
    detail: 'Si ya se configuró antes, restablécelo de fábrica antes de empezar.',
};

const ONLINE_STEP: DeviceEnrollmentStep = {
    action: 'Prende el equipo y conéctalo a internet',
    detail: 'Por wifi o datos, y que siga conectado durante toda la configuración inicial.',
};

const FINISH_STEP: DeviceEnrollmentStep = {
    action: 'Termina la configuración y deja el equipo prendido y conectado',
    detail: 'El equipo se reporta solo con el proveedor y esta pantalla avanza sola.',
};

/** Trustonic sin método de alta conocido: cubre las dos pantallas posibles. */
export const TRUSTONIC_GENERIC_STEPS: readonly DeviceEnrollmentStep[] = [
    FACTORY_FRESH_STEP,
    ONLINE_STEP,
    { action: 'Avanza la configuración inicial de Android' },
    {
        action: 'Acepta las pantallas de Trustonic o de Knox Guard',
        detail: 'En «Samsung Knox Guard» toca «Registrar este dispositivo». En las de Trustonic acepta cada una y toca «Obtener».',
    },
    FINISH_STEP,
];

/** Trustonic en equipos Samsung: el alta la abre la pantalla de Knox Guard. */
export const TRUSTONIC_KNOX_GUARD_STEPS: readonly DeviceEnrollmentStep[] = [
    FACTORY_FRESH_STEP,
    ONLINE_STEP,
    { action: 'Avanza la configuración inicial hasta la pantalla «Samsung Knox Guard»' },
    {
        action: 'Toca «Registrar este dispositivo»',
        detail: 'Si el equipo está en inglés, aparece como «Enroll this device».',
    },
    FINISH_STEP,
];

/** Trustonic en los demás modelos: el alta la abren las pantallas de Trustonic. */
export const TRUSTONIC_PAY_TRIGGER_STEPS: readonly DeviceEnrollmentStep[] = [
    FACTORY_FRESH_STEP,
    ONLINE_STEP,
    {
        action: 'Acepta la pantalla «Este dispositivo lo proporciona Trustonic»',
        detail: 'En inglés: «This device is provided by Trustonic».',
    },
    {
        action: 'Acepta la pantalla «Cómo puede administrar Trustonic este dispositivo»',
        detail: 'En inglés: «How Trustonic can manage this device».',
    },
    { action: 'Toca «Obtener»', detail: 'En inglés aparece como «Get».' },
    FINISH_STEP,
];

/** Motosafe: el alta va por servidor y el teléfono la aplica al sincronizarse con internet. */
export const MOTOSAFE_STEPS: readonly DeviceEnrollmentStep[] = [
    {
        action: 'Prende el teléfono del cliente y conéctalo a internet',
        detail: 'Con Wi-Fi o datos. El candado de Motorola se activa solo cuando el teléfono se sincroniza; no hay app que instalar.',
    },
];
